<template>
  <div class="mb-10 xl:mb-36">
    <div id="tentang">
      <img
        src="../assets/bg-header.webp"
        alt=""
        class="w-3/12 md:w-4/12 xl:w-3/12 xl:-mt-40"
      />
      <h3
        class="karla md:text-xl xl:text-2xl text-cBlue font-semibold text-center tracking-wider -mt-20 md:-mt-32 lg:-mt-52 xl:-mt-56"
      >
        APA SIH SEDEKAH KUY ITU ?
      </h3>
      <img
        src="../assets/bg-about.svg"
        alt=""
        class="absolute -ml-12 opacity-5 inset-x-2/4 -mt-12"
      />
      <hr
        class="mx-auto w-7/12 md:w-5/12 lg:w-4/12 xl:w-3/12 border mt-3 border-cLightBlue"
      />
      <p
        class="mt-8 mx-6 text-xs md:text-sm md:mx-44 lg:mx-72 lg:px-2 xl:mx-96 xl:px-4 xl:mt-10 tracking-wide xl:text-lg"
      >
        Sedekah Kuy adalah sebuah komunitas yang bergerak di bidang sosial
        sekaligus wadah penyalur donasi dari para donatur baik dalam internal
        grup maupun eksternal yang menjunjung tinggi nilai
        <span class="text-cBlue font-semibold">keikhlasan</span>
      </p>
    </div>
    <div id="visi-misi">
      <img
        src="../assets/bg-misi.webp"
        alt=""
        class="hidden xl:absolute right-0 w-full mt-10 xl:w-3/12 xl:-mt-16"
      />
      <h3
        class="karla md:text-lg xl:text-2xl text-cBlue font-semibold text-center tracking-wider mt-16 md:mt-40 xl:mt-40"
      >
        VISI & MISI SeKuy APA SIH ?
      </h3>
      <img
        src="../assets/bg-visi.svg"
        alt=""
        class="absolute -ml-12 inset-x-2/4 -mt-12"
      />
      <hr
        class="mx-auto w-7/12 md:w-4/12 lg:w-3/12 xl:w-3/12 border mt-3 border-cLightBlue"
      />
      <div
        class="relative grid mx-10 gap-6 mt-10 md:grid-cols-2 lg:mx-40 xl:gap-8 xl:mx-80 xl:mt-12"
      >
        <div class="text-center shadow-lg py-10 px-7">
          <img src="../assets/visi.svg" alt="" class="mx-auto" />
          <h4 class="source text-2xl mt-8 mb-4 font-semibold">Visi SeKuy</h4>
          <p class="text-left mr-3">
            menjadi
            <span class="font-semibold text-cBlue"
              >komunitas agent perubahan</span
            >
            (Artinya kami berharap dengan adanya sekuy ini pihak penerima donasi
            maupun pemberi donasi bisa menjadi perubahan ke arah yang lebih baik
          </p>
        </div>
        <div class="text-center shadow-lg py-10 px-7">
          <img src="../assets/misi.svg" alt="" class="mx-auto" />
          <h4 class="source text-2xl mt-8 mb-4 font-semibold">Misi SeKuy</h4>
          <ul class="text-sm text-left">
            <li>
              <div class="flex my-2">
                <p class="text-red-500">*</p>
                <p class="ml-2">
                  Mencetak muda-mudi yang mempunyai kepedulian yang tinggi
                  terhadap sesama dan lingkungannya.
                </p>
              </div>
            </li>
            <li>
              <div class="flex my-2">
                <p class="text-red-500">*</p>
                <p class="ml-2">Mempererat silaturahmi antar sesama.</p>
              </div>
            </li>
            <li>
              <div class="flex my-2">
                <p class="text-red-500">*</p>
                <p class="ml-2">
                  Menjadi wadah / penyalur yang bisa dipercaya.
                </p>
              </div>
            </li>
            <li>
              <div class="flex my-2">
                <p class="text-red-500">*</p>
                <p class="ml-2">
                  Menjadi komunitas yang bisa memotivasi semua orang untuk gemar
                  bersedekah.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style>
</style>